import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { formatDate } from '@/utils/dateFormatting';

interface OverviewMetaFooterProps {
  createdByNickname: string | null;
  createdBy: string | null;
  createdAt: string;
}

const OverviewMetaFooter: React.FC<OverviewMetaFooterProps> = ({ createdByNickname, createdBy, createdAt }) => {
  const { t } = useTranslation(['overview', 'common']);
  const creator = createdByNickname || createdBy || t('common:unknown');

  return (
    <footer className="overview-meta-row">
      <Trans
        i18nKey="overview:metaFooter.familyCreatedBy"
        values={{ name: creator, date: formatDate(createdAt) }}
        components={{ strong: <strong /> }}
      />
    </footer>
  );
};

export default OverviewMetaFooter;
